import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AppUpdateService } from '../../core/services/app-update.service';

@Component({
  selector: 'app-update',
  templateUrl: './app-update.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateComponent {
  private readonly appUpdateService = inject(AppUpdateService);

  protected activateUpdate(): void {
    this.appUpdateService.activateUpdate();
  }
}
